import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { compose, withState, withHandlers, setPropTypes } from 'recompose'
import CloseIcon from 'react-feather/dist/icons/x'
import Button from '../Button/Button'
import {
  Backdrop,
  ModalWrapper,
  ButtonWrapper
} from './styles'

const Modal = ({ children, isOpen, lg, sm, noCloseIcon, animateOut, onAnimateOut }) => {
  if (!isOpen) { return null }

  return ReactDOM.createPortal(
    <Backdrop animateOut={animateOut}>
      <ModalWrapper lg={lg} sm={sm} animateOut={animateOut}>
        {
          !noCloseIcon && <ButtonWrapper>
            <Button size={20} icon onClick={onAnimateOut}>
              <CloseIcon size={18} />
            </Button>
          </ButtonWrapper>
        }
        {children}
      </ModalWrapper>
    </Backdrop>,
    document.getElementById('modal')
  )
}

export default compose(
  setPropTypes({
    onClose: PropTypes.func
  }),
  withState('animateOut', 'setAnimateOut', false),
  withHandlers({
    onAnimateOut: ({ onClose, setAnimateOut }) => {
      setAnimateOut(true)
      setTimeout(() => {
        onClose()
        setAnimateOut(false)
      }, 200)
    }
  })
)(Modal)



// WEBPACK FOOTER //
// ./src/Components/Modal/Modal.jsx